import { FC } from 'react';
import { ActiveSourceConnectorDataSource, PendingSourceConnectorDataSource } from './sourceConnector';
import { OverviewTabProps } from './types/types';

export const SourceConnectorOverview: FC<OverviewTabProps> = ({ dataSource, isActive }) => {
  return isActive ? (
    <ActiveSourceConnectorDataSource dataSource={dataSource} isActive={isActive} />
  ) : (
    <PendingSourceConnectorDataSource dataSource={dataSource} isActive={isActive} />
  );
};
